// NPM Modules
import { combineReducers } from 'redux';
// Actions
import { types } from '../actions/array';
// Reducer Template
import get from './templates/get';
import post from './templates/post';
import list from './templates/list';
// Reducer
export default combineReducers({
  info: (s, a) => get(s, a, types.info),
  list: (s, a) => list(s, a, types.list),
  matList: (s, a) => list(s, a, types.matList),
  create: (s, a) => post(s, a, types.create),
  edit: (s, a) => post(s, a, types.edit),
  remove: (s, a) => post(s, a, types.remove)
});
